import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, normalizeClass as _normalizeClass, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "participant-grid-wrapper" }
const _hoisted_2 = {
  key: 1,
  class: "selection-bar"
}
const _hoisted_3 = { class: "selection-bar-left" }
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "selection-bar-text" }
const _hoisted_6 = { class: "selection-bar-actions" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "delete-dropdown-wrapper" }
const _hoisted_13 = ["src"]
const _hoisted_14 = {
  key: 0,
  class: "delete-dropdown"
}
const _hoisted_15 = { class: "cell-email" }
const _hoisted_16 = { class: "invite-icons" }
const _hoisted_17 = {
  key: 0,
  class: "badge badge-green"
}
const _hoisted_18 = {
  key: 1,
  class: "badge badge-yellow"
}
const _hoisted_19 = {
  key: 2,
  class: "badge badge-red"
}
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "platform-icons" }
const _hoisted_22 = ["src"]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = {
  key: 3,
  class: "platform-none"
}
const _hoisted_26 = { class: "chips" }
const _hoisted_27 = {
  key: 0,
  class: "chip"
}
const _hoisted_28 = { class: "ticket-chips" }
const _hoisted_29 = { class: "ticket-chip-icon" }
const _hoisted_30 = { class: "ticket-chip-name" }
const _hoisted_31 = {
  key: 0,
  class: "chip"
}
const _hoisted_32 = { class: "grid-empty-state" }
const _hoisted_33 = { class: "grid-empty-title" }
const _hoisted_34 = { class: "grid-empty-subtitle" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_IdentityCard = _resolveComponent("IdentityCard")!
  const _component_KebabMenu = _resolveComponent("KebabMenu")!
  const _component_GridNoRecords = _resolveComponent("GridNoRecords")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showModalPopup)
      ? (_openBlock(), _createBlock(_component_ModalPopup, {
          key: 0,
          "show-modal-popup": _ctx.showModalPopup,
          "header-content": _ctx.modalPopupHeading,
          "body-heading": _ctx.modalPopupBodyHeading,
          "body-content": _ctx.modalPopupBodyContent,
          "show-cancel-button": _ctx.modalPopupShowCancelButton,
          "cancel-button-text": _ctx.modalPopupCancelButtonText,
          "confirm-button-text": _ctx.modalPopupConfirmButtonText,
          "show-close-button": _ctx.showCloseButton,
          "image-url": _ctx.modalPopupIcon,
          onConfirmClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.ConfirmClick($event)))
        }, null, 8, ["show-modal-popup", "header-content", "body-heading", "body-content", "show-cancel-button", "cancel-button-text", "confirm-button-text", "show-close-button", "image-url"]))
      : _createCommentVNode("", true),
    (_ctx.isAllPagesSelected || _ctx.selectedIds.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "selection-bar-close",
              title: _ctx.$t('Participant.Grid.DeselectAll'),
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.DeselectAll && _ctx.DeselectAll(...args)))
            }, " × ", 8, _hoisted_4),
            _createElementVNode("span", _hoisted_5, [
              (_ctx.isAllPagesSelected)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Participant.Grid.SelectedAll')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.totalCount), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Grid.Participants')), 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('Participant.Grid.SelectedCount')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.selectedIds.length), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Grid.ParticipantsOutOf')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.totalCount), 1)
                  ], 64))
            ]),
            (!_ctx.isAllPagesSelected)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "javascript:void(0)",
                  class: "selection-bar-select-all",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.SelectAll && _ctx.SelectAll(...args)))
                }, _toDisplayString(_ctx.$t('SelectAll')), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.OnBulkAction('assign-ticket')))
            }, [
              _createElementVNode("img", {
                class: "menu-item-icon",
                src: _ctx.revokeIcon,
                alt: "assign-ticket"
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.Grid.AssignTicket')), 1)
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnBulkAction('revoke-ticket')))
            }, [
              _createElementVNode("img", {
                class: "menu-item-icon",
                src: _ctx.revokeIcon,
                alt: "revoke-ticket"
              }, null, 8, _hoisted_8),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.Edit.RevokeTicket')), 1)
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.OnBulkAction('assign-group')))
            }, [
              _createElementVNode("img", {
                class: "menu-item-icon",
                src: _ctx.groupIcon,
                alt: "assign-group"
              }, null, 8, _hoisted_9),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.Grid.AssignToGroup')), 1)
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OnBulkAction('send-email')))
            }, [
              _createElementVNode("img", {
                class: "menu-item-icon",
                src: _ctx.emailIcon,
                alt: "send-email"
              }, null, 8, _hoisted_10),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.Grid.SendEmail')), 1)
            ]),
            _createElementVNode("div", {
              class: "menu-item",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OnBulkAction('export')))
            }, [
              _createElementVNode("img", {
                class: "menu-item-icon",
                src: _ctx.exportIcon,
                alt: "export"
              }, null, 8, _hoisted_11),
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Participant.Export')), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", {
                class: "menu-item menu-item--delete",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.showDeleteDropdown = !_ctx.showDeleteDropdown), ["stop"]))
              }, [
                _createElementVNode("img", {
                  class: "menu-item-icon",
                  src: _ctx.deleteIcon,
                  alt: "delete"
                }, null, 8, _hoisted_13),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('Button.Delete')), 1)
              ]),
              (_ctx.showDeleteDropdown)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", {
                      class: "delete-dropdown-item",
                      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.OnDeleteAction('delete-from-event')))
                    }, _toDisplayString(_ctx.$t('Participant.Grid.DeleteFromThisEvent')), 1),
                    _createElementVNode("div", {
                      class: "delete-dropdown-item",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.OnDeleteAction('delete-from-all-events')))
                    }, _toDisplayString(_ctx.$t('Participant.Grid.DeleteFromAllEvents')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Grid, {
      "data-items": _ctx.gridRows,
      columns: _ctx.columns,
      resizable: false,
      sort: _ctx.sort,
      sortable: true,
      scrollable: 'scrollable',
      pageable: _ctx.pagerOptions,
      skip: _ctx.serverSkip,
      take: _ctx.serverPageSize,
      total: _ctx.totalCount,
      "selected-field": 'selected',
      class: _normalizeClass(["participant-grid", { 'no-vertical-scroll': !_ctx.hasVerticalScroll }]),
      onRowclick: _ctx.RowClicked,
      onPagechange: _ctx.onPageChange,
      onSelectionchange: _ctx.onSelectionChange,
      onHeaderselectionchange: _ctx.onHeaderSelectionChange,
      onSortchange: _ctx.onSortChange
    }, {
      cellEmail: _withCtx(({ props }) => [
        _createElementVNode("td", _normalizeProps(_guardReactiveProps(props)), [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_IdentityCard, {
              size: 32,
              title: props.dataItem.Email,
              "first-name": props.dataItem.FirstName,
              "last-name": props.dataItem.LastName,
              "image-url": props.dataItem.IconUrl
            }, null, 8, ["title", "first-name", "last-name", "image-url"])
          ])
        ], 16)
      ]),
      cellName: _withCtx(({ props }) => [
        _createElementVNode("td", _normalizeProps(_guardReactiveProps(props)), [
          _createElementVNode("span", null, _toDisplayString(_ctx.getName(props.dataItem)), 1)
        ], 16)
      ]),
      cellInviteEmail: _withCtx(({ props }) => [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getEmailStatusClass(props.dataItem.OverallStatus)])
            }, _toDisplayString(props.dataItem.InviteEmailStatus), 3)
          ])
        ])
      ]),
      cellStatus: _withCtx(({ props }) => [
        _createElementVNode("td", null, [
          ((props.dataItem.RegistrationStatus || '').toLowerCase() === 'attending')
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('Participant.Attending')), 1))
            : ((props.dataItem.RegistrationStatus || '').toLowerCase() === 'invited')
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('Participant.Invited')), 1))
              : ((props.dataItem.RegistrationStatus || '').toLowerCase() === 'not attending')
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t('Participant.NotAttending')), 1))
                : (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: "javascript:void(0)",
                    class: "hyper-link",
                    onClick: _withModifiers(($event: any) => (_ctx.SendEmail(props.dataItem)), ["stop"])
                  }, _toDisplayString(_ctx.$t('Participant.SendInvite')), 9, _hoisted_20))
        ])
      ]),
      cellDateTime: _withCtx(({ props }) => [
        _createElementVNode("td", null, [
          _createElementVNode("span", null, _toDisplayString(_ctx.formatDateTime(_ctx.resolveField(props.dataItem, props.field))), 1)
        ])
      ]),
      cellPlatform: _withCtx(({ props }) => [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_21, [
            (props.dataItem.JoinedByIOS)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.iosIcon,
                  class: "platform-icon",
                  title: "iOS",
                  alt: "iOS"
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true),
            (props.dataItem.JoinedByAndroid)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.androidIcon,
                  class: "platform-icon",
                  title: "Android",
                  alt: "Android"
                }, null, 8, _hoisted_23))
              : _createCommentVNode("", true),
            (props.dataItem.JoinedByPWA)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 2,
                  src: _ctx.pwaIcon,
                  class: "platform-icon",
                  title: "PWA",
                  alt: "PWA"
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (!props.dataItem.JoinedByIOS && !props.dataItem.JoinedByAndroid && !props.dataItem.JoinedByPWA)
              ? (_openBlock(), _createElementBlock("span", _hoisted_25, "-"))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      cellGroups: _withCtx(({ props }) => [
        _createElementVNode("td", null, [
          _createElementVNode("div", _hoisted_26, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.dataItem.groups || []).slice(0, _ctx.maxVisibleGroups), (g, idx) => {
              return (_openBlock(), _createElementBlock("span", {
                key: idx,
                class: "chip"
              }, _toDisplayString(g), 1))
            }), 128)),
            ((props.dataItem.groups || []).length > _ctx.maxVisibleGroups)
              ? (_openBlock(), _createElementBlock("span", _hoisted_27, "+" + _toDisplayString((props.dataItem.groups || []).length - _ctx.maxVisibleGroups), 1))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      cellTickets: _withCtx(({ props }) => [
        _createElementVNode("td", _normalizeProps(_guardReactiveProps(props)), [
          _createElementVNode("div", _hoisted_28, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((props.dataItem.ParticipantTicketDetails || []).slice(0, 2), (ticket, idx) => {
              return (_openBlock(), _createElementBlock("span", {
                key: idx,
                class: _normalizeClass(["ticket-chip", ticket.IsCheckedIn ? 'ticket-chip--green' : 'ticket-chip--yellow'])
              }, [
                _createElementVNode("span", _hoisted_29, _toDisplayString(ticket.IsCheckedIn ? '✓' : '—'), 1),
                _createElementVNode("span", _hoisted_30, _toDisplayString(ticket.TicketName), 1)
              ], 2))
            }), 128)),
            ((props.dataItem.ParticipantTicketDetails || []).length > 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_31, "+" + _toDisplayString((props.dataItem.ParticipantTicketDetails || []).length - 2), 1))
              : _createCommentVNode("", true)
          ])
        ], 16)
      ]),
      cellExtraInfo: _withCtx(({ props }) => [
        _createElementVNode("td", _normalizeProps(_guardReactiveProps(props)), [
          _createElementVNode("span", null, _toDisplayString(_ctx.GetParticipantExtraInfo(props.dataItem, props.field)), 1)
        ], 16)
      ]),
      cellActions: _withCtx(({ props }) => [
        _createElementVNode("td", _normalizeProps(_guardReactiveProps(props)), [
          _createVNode(_component_KebabMenu, {
            "data-item": props.dataItem
          }, null, 8, ["data-item"])
        ], 16)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_GridNoRecords, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_32, [
              _cache[12] || (_cache[12] = _createElementVNode("svg", {
                class: "grid-empty-icon",
                viewBox: "0 0 80 80",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("circle", {
                  cx: "40",
                  cy: "28",
                  r: "18",
                  fill: "#E5E7EB"
                }),
                _createElementVNode("ellipse", {
                  cx: "40",
                  cy: "64",
                  rx: "28",
                  ry: "14",
                  fill: "#E5E7EB"
                })
              ], -1)),
              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.$t('Participant.Grid.NoParticipants')), 1),
              _createElementVNode("div", _hoisted_34, [
                _createTextVNode(_toDisplayString(_ctx.$t('Participant.Grid.NoParticipantsHint1')) + " ", 1),
                _createElementVNode("a", {
                  href: "javascript:void(0)",
                  class: "grid-empty-link",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('import-click')))
                }, _toDisplayString(_ctx.$t('Participant.Import')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('Participant.Grid.NoParticipantsHint2')), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-items", "columns", "sort", "pageable", "skip", "take", "total", "class", "onRowclick", "onPagechange", "onSelectionchange", "onHeaderselectionchange", "onSortchange"])
  ]))
}